/**
 * @file 获取举报策略
 * @see http://api.umucdn.cn/project/46/interface/api/4751
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

import { REPORT_CATEGORY_TYPE } from '@umu/umu-types';

// todo
export interface IInput {
    data: string; // json IInputData
}

export interface IOption {
    // tslint:disable-next-line:max-line-length
    key: 'from_user_page' | 'violation_url' | 'violation_user_page';
    value: string;
}

export interface IInputData {
    target_id: string; // 对象ID(circle/sessionId/userId)
    category: REPORT_CATEGORY_TYPE;
    problem: number;
    args: IOption[];
}

export interface IOutput {
    status: number;
}

export const reportIssue = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.REPORT_ISSUE, data, { silent: true });
};
